// extracted by mini-css-extract-plugin
export default {"grid":"grid__lR_N7"};